import * as React from 'react';
import { useEffect, useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Box from "@material-ui/core/Box";
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import {
    AttachFile,
    BusinessCenterOutlined,
    EditOutlined,
    Email,
    LocationOnOutlined,
    PermIdentity,
    Print
} from "@material-ui/icons";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { enums } from "../../enums/enums";
import { IUsuario } from "../../entities/catalogos/IUsuario";
import { IconButton, Paper } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import { saveMercancias } from "../../redux/actions/mercanciaActions";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { setRecoleccionDestino, setRecoleccionOrigen } from "../../redux/actions/recoleccionActions";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { Mercancia } from "../../entities/solicitudes/Mercancia";
import TableContainer from "@material-ui/core/TableContainer";
import useCommonApi from '../../api/useCommonApi';
import { ServicioAdicional } from '../../entities/catalogos/ServicioAdicional';
import { ICliente } from '../../entities/catalogos/ICliente';
import Map from '../map/Map';
import LoadingDialog from '../controls/LoadingDialog';
import swal from 'sweetalert2'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import EnviarCorreoDialog from '../controls/EnviarCorreoDialog';
import ImprimirDialog from '../controls/ImprimirDialog';
import { b64toBlob, currencyFormat } from "../../blocks/utility";
import ConfirmDialog from "../controls/ConfirmDialog";
import { traducirButton, traducirLabel, traducirMessage } from '../../blocks/traductor';



const useStyles = makeStyles(() =>
    createStyles({
        root: {
            width: '100%',
            borderCollapse: 'collapse',
            '& td': {
                paddingLeft: "1em"
            },
            '& td:nth-child(odd)': {
                backgroundColor: "#F8F8F8",
                borderLeft: "3px solid #066336",
                paddingRight: "1em"
            },
            '& tr:last-child td': {
                paddingBottom: "1em"
            }
        },
        icon: {
            width: "30px",
            height: "30px",
            minWidth: "30px",
            borderRadius: "15px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "right",
        },
        tableSummary: {
            width: '100%',
            '& td': {
                paddingLeft: "0"
            },
            '& td.price': {
                textAlign: "right"
            }
        },
        total: {
            color: 'white',
            fontWeight: 'bold'
        },
        mensajePrecio: {
            color: 'white',
        },
        mainTitle: {
            color: "#19754e",
            fontSize: "18px",
            fontWeight: "bold"
        },
        title: {
            color: "#19754e",
            fontSize: "10px",
            fontWeight: "bold",
            marginTop: "2em",
            marginBottom: "0.2em",
            '& td': {
                paddingTop: "1em",
                paddingBottom: "0.2em"
            }
        },
        link: {
            color: "#0094ff",
            fontSize: "12px",
            fontWeight: 500,
            cursor: "pointer"
        },
        information: {
            color: "#212121",
            fontSize: "14px",
            fontWeight: 500
        },
        additional: {
            color: " rgba(49,49,49,0.87)",
            fontSize: "12px"
        },
        facturador: {
            color: "#19754e",
            fontSize: "10px",
            fontWeight: "bold",
            marginTop: "2em",
            marginBottom: "0.2em",
            '& td': {
                paddingTop: "2em",
                paddingBottom: "0.2em"
            },


        },
        seccionTitulo: {
            color: "#338462"
        },
        noborder: {
            borderLeft: "none !important",
            paddingRight: "none !important",
            backgroundColor: "#Fff !important",
        },
        infoCliente: {
            fontSize: "12px",
            width: "30%"
        },
        oval: {
            backgroundColor: "#ECECEC",
            color: "#000",
            borderRadius: "10px",
            width: "20px",
            height: "20px",
            margin: "0 10px 5px"
        }
    }),
);

interface OwnProps {
    cotizacionId: number
    siguienteSeccion: (estatusId: number, cotizacionCopia: Solicitud) => void
    datosRemitente?: any
    datosDestinatario?: any

}

interface StateProps {
    solicitud: Solicitud
    usuario: IUsuario
    mercancias: Mercancia[]
    solicitudCopia: Solicitud
    serviciosAdicionales: ServicioAdicional[]
    cliente: ICliente
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    saveMercancias: typeof saveMercancias
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
}

type Props = StateProps & DispatchProps & OwnProps;

let recoleccionConversion = {
    0: "",
    [enums.tipoRecoleccion.ocurre]: traducirLabel(288),//"Sucursal",
    [enums.tipoRecoleccion.comercial]: traducirLabel(44),//"Comercio",
    [enums.tipoRecoleccion.residencial]: traducirLabel(103),//"Domicilio",
};
const apiSource = useCommonApi();

const tiposImpresion = {
    normal: {
        nombreLink: "SolicitudServicio-",
        textoError: "Ocurrio un error al imprimir el formato de la solicitud.",
        api: "/solicitud-servicio/solicitud-servicio-pdf/"
    },
    etiquetadora: {
        nombreLink: "EtiquetasSolicitudServicio--",
        textoError: "Ocurrio un error al imprimir el formato de la impresión etiquetadora.",
        api: "/solicitud-servicio/impresion-etiqueta4X4/"
    },
    lasser: {
        nombreLink: "EtiquetasLasser-",
        textoError: "Ocurrio un error al imprimir el formato de la impresión lasser.",
        api: "/solicitud-servicio/impresion-etiquetas-para-laser/"
    }
}

const ResumenConfirmacionSS = (props: Props) => {
    const classes = useStyles();
    const [formaEnvio, setFormaEnvio] = useState("");
    const [entrega, setEntrega] = useState("");
    const [fechaRad, setFechaRad] = useState("");
    const [fechaEad, setFechaEad] = useState("");
    const registrarUsuario = false;
    const [showLoading, setLoading] = useState(false);
    const [showEnviarCorreo, setShowEnviarCorreo] = useState(false);
    const [opcionesEnvio, setOpcionesEnvio] = useState({ dialogOpen: false, terminado: false, tipoImpresion: {} });

    useEffect(() => {
        const tipoRecoleccionOrigenId = props.solicitud.tipoRecoleccionIdOrigen ? props.solicitud.tipoRecoleccionIdOrigen : 0;
        const tipoRecoleccionDestinoId = props.solicitud.tipoRecoleccionIdDestino ? props.solicitud.tipoRecoleccionIdDestino : 0;

        if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.ocurre){
            setFormaEnvio(traducirLabel(255)+` ${traducirLabel(288)}`);
        }
        if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.comercial){
            setFormaEnvio(traducirLabel(255)+` ${traducirLabel(44)}`);
        }
        if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.residencial){
            setFormaEnvio(traducirLabel(255)+` ${traducirLabel(103)}`);
        }
        if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.ocurre){
            setEntrega(traducirLabel(115)+` ${traducirLabel(288)}`);
        }
        if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.comercial){
            setEntrega(traducirLabel(115)+` ${traducirLabel(44)}`);
        }
        if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.residencial){
            setEntrega(traducirLabel(115)+` ${traducirLabel(103)}`);
        }
        
        let fechaRad = obtieneFechaRadEad(props.solicitud.EsRadCitaFueraHorario, props.solicitud.fechaCitaRad, props.solicitud.RadCitaHoraDe, props.solicitud.RadCitaHoraHasta);
        let fechaEad = obtieneFechaRadEad(props.solicitud.EsEadCitaFueraHorario, props.solicitud.fechaCitaEad, props.solicitud.EadCitaHoraDe, props.solicitud.EadCitaHoraHasta);
        if(props.solicitud.fechaCitaRad === undefined)
            fechaRad = obtieneFechaRadEad(props.solicitud.EsRadCitaFueraHorario, props.solicitud.fechaCitaRadCedis, props.solicitud.RadCitaHoraDe, props.solicitud.RadCitaHoraHasta);
        if(props.solicitud.fechaCitaEad === undefined)
            fechaEad = obtieneFechaRadEad(props.solicitud.EsEadCitaFueraHorario, props.solicitud.fechaCitaEadCedis, props.solicitud.EadCitaHoraDe, props.solicitud.EadCitaHoraHasta);
        
        setFechaRad(fechaRad);
        setFechaEad(fechaEad);
    }, []);

    const obtieneFechaRadEad = (esFueraHorario, fecha, horaDe, horaHasta) => {
        let fechaString = "";
        let language = 'es';
        if(localStorage.getItem("idioma")==='en-US'){
            language = 'en';
        }
        
        if (esFueraHorario) {
            if (fecha !== undefined && fecha !== null) {
                let ampm1;
                let ampm2;
                let hours1 = horaDe.split(':');
                let hours2 = horaHasta.split(':');
                if (parseInt(hours1[0]) > 11)
                    ampm1 = "p.m.";
                else
                    ampm1 = "a.m."

                if (parseInt(hours2[0]) > 11)
                    ampm2 = "p.m.";
                else
                    ampm2 = "a.m."

                fechaString = new Date(fecha).toLocaleString(language, { day: "numeric", month: "short", year: "numeric" })
                    + " " + horaDe + " " + ampm1 + " - " + horaHasta + " " + ampm2
            }
        }
        else {
            let fechaOffset = new Date(fecha);
            fechaString = fecha ? `${new Date(fechaOffset).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: false })}` : ""
        }
        return fechaString;
    }

    const cambiarSeccion = (seccionId, expandeDestinatario = false) => {
        const nuevaCotizacion = new Solicitud({ ...props.solicitud, seccionId: seccionId, expandeDestinatario: expandeDestinatario });
        props.setSolicitud(nuevaCotizacion);
        //Copia todos los valores de la solicitud a su copia para reestablecer los valores en el Resumen
        props.setSolicitudCopia(nuevaCotizacion);
    };

    const [imprimirAbierto, setImprimirAbierto] = useState(false);

    const cerrarImprimir = () => {
        setImprimirAbierto(false);
    };

    const imprimir = () => {
        setImprimirAbierto(true);
    }

    const handleImprimir = (esDesdeConfirmacion, tipoImpresion) => {
        if (!opcionesEnvio.terminado && !esDesdeConfirmacion) {
            setOpcionesEnvio({ ...opcionesEnvio, dialogOpen: true, tipoImpresion });
            return;
        }

        setImprimirAbierto(false);
        setLoading(true);
        imprimirCall(tipoImpresion.api).then(response => {
            setLoading(false);
            const blob = b64toBlob(response, 'application/pdf');
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = tipoImpresion.nombreLink + props.solicitud.numGuia + ".pdf";
            link.click();
        }).catch(() => {
            setLoading(false);
            swal.fire({
                titleText: traducirMessage(276), // '¡Atención!',
                text: traducirMessage(215), // "Ocurrio un error al imprimir el formato de la solicitud.",
                type: 'error',
            });
        });
    }

    const imprimirSolicitud = () => {
        handleImprimir(false, tiposImpresion.normal);
    };

    const imprimirEtiquetadora = () => {
        handleImprimir(false, tiposImpresion.etiquetadora);
    };

    const imprimirLasser = () => {
        handleImprimir(false, tiposImpresion.lasser);
    };

     const imprimirCall = async (api: string) => {
        const result = await apiSource.postAsync<any>(api + props.solicitud.id);
        return result;
    }

    const enviarCorreo = () => {
        setShowEnviarCorreo(true);
    }

    const confirmarEnviarCorreo = (esTerminarSolicitud) => {
        swal.fire({
            titleText: traducirMessage(14), //'¡Exitoso!',
            text: traducirMessage(54), // "El correo fue enviado exitosamente.",
            type: 'success',
        });

        setShowEnviarCorreo(false);

        if (esTerminarSolicitud && !opcionesEnvio.terminado) {
            terminarSolicitud(false);
        }
    }

    const cerrarEnviarCorreo = () => {
        setShowEnviarCorreo(false);
    }

    const b64toBlobFile = (row, contentType = '') => {
        let byteCharacters: any;
        if (row.nombreArchivo) {
            byteCharacters = atob(row.base64);
        } else if (row.nombre) {
            byteCharacters = atob(row.file64);
        }

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: row.tipo });
        let extension = row.tipo.indexOf("pdf") !== -1 ? "pdf" : "docx"

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        if (row.nombreArchivo) {
            link.download = `${row.nombreArchivo}`;
        } else if (row.nombre) {
            link.download = `${row.nombre}`;
        }

        link.click();

        return blob;
    }

    const handleDownload = (row) => {
        b64toBlobFile(row);
    }

    const terminarSolicitud = (esImprimir: boolean) => {
        const solicitudCopia = new Solicitud(props.solicitud);
        solicitudCopia.enviada = true;
        props.setSolicitud(solicitudCopia);

        if (esImprimir) {
            handleImprimir(true, opcionesEnvio.tipoImpresion);
        }
        setOpcionesEnvio({ ...opcionesEnvio, dialogOpen: false, terminado: true });
    }

    const puedeEditar = (): boolean => {
        return !!props.solicitud.modificar && !opcionesEnvio.terminado;
    };

    return (<>
        {!registrarUsuario &&
            <>
                <Paper>
                    <Box display="flex" px={3} pt={2} alignItems="center" flexWrap="wrap">
                        <Box className={classes.mainTitle} flexGrow={1}>
                            {/* SOLICITUD SERVICIO  */
                                traducirLabel(284)} <span style={{ color: "#000", textDecoration: "underline" }}>{props.solicitud.numGuia}</span>
                        </Box>

                        {props.solicitud.id > 0 &&
                            <Box m={1}>
                                <Button color="primary" onClick={imprimir}>
                                    <Print /> {/* Imprimir */ traducirLabel(164)}
                                </Button>
                                <Button color="primary" onClick={enviarCorreo}>
                                    <Email /> {/* Enviar por Email */ traducirLabel(121)}
                                </Button>
                            </Box>
                        }
                    </Box>

                    <Box p={3} pt={2}>
                        <Divider />

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8}>
                                <Box display="flex" flexDirection="column">
                                    <Box display="flex" mb={1} mt={3}>
                                        <PermIdentity />
                                        <Box ml={1}>
                                            <b className={classes.seccionTitulo}>
                                                {/* Datos  Cliente */
                                                    traducirLabel(67)}
                                            </b>
                                        </Box>
                                        {puedeEditar() &&
                                            <>
                                                <Box ml={1}>
                                                    <IconButton color="default" size="small" className={classes.oval}
                                                        onClick={() => cambiarSeccion(enums.estatusSolicitud.datosCliente)}>
                                                        <EditOutlined style={{ fontSize: 15 }} />
                                                    </IconButton>
                                                </Box>
                                            </>
                                        }
                                    </Box>

                                    <Box ml={4}>
                                        <table >
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: "400px" }} className={classes.infoCliente} >

                                                        <Box><strong>{!props.solicitudCopia.nombreTarifaAlmex ? props.cliente.nombre : props.solicitudCopia.nombreTarifaAlmex}</strong></Box>
                                                        <Box>{props.solicitudCopia.empresaTarifaAlmex}</Box>
                                                        <Box>{!props.solicitudCopia.telefonoTarifaAlmex ? props.cliente.telefono : props.solicitudCopia.telefonoTarifaAlmex}</Box>
                                                        <Box>{props.solicitud.correo}</Box>
                                                    </td>
                                                    <td className={classes.infoCliente}>
                                                        {props.cliente.grupoClienteID >= 0 && (props.cliente.clienteCreditoProyecto && props.cliente.clienteCreditoProyecto?.length >= 2) &&
                                                            <Box><div><strong>
                                                                {/* PROYECTO */
                                                                    traducirLabel(241)}
                                                            </strong>&nbsp;<span>{props.solicitudCopia.proyecto?.descripcion}</span></div></Box>
                                                        }
                                                        <br />
                                                        {props.cliente.habilitarClienteLogistico && props.solicitud.facturador?.id !== props.cliente.id && (props.solicitud?.facturador?.id ?? 0) > 0 &&
                                                            <Box><div> <strong>
                                                                {/* FACTURADOR */
                                                                    traducirLabel(127)}
                                                            </strong>&nbsp;<span>{props.solicitud.facturador?.clienteNombre}</span></div></Box>
                                                        }
                                                    </td>
                                                    <td className={classes.infoCliente}>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Box>
                                </Box>

                                <br />
                                <Divider />

                                <Box display="flex" flexDirection="column" mt={3}>
                                    <Box display="flex" mb={1}>
                                        <LocationOnOutlined />
                                        <Box ml={1}><b className={classes.seccionTitulo}>
                                            {/* Origen y Destino */
                                                traducirLabel(223)}
                                        </b></Box>
                                    </Box>

                                    <table className={classes.root}>
                                        <tbody>
                                            <tr>
                                                <td className={classes.noborder} >

                                                    <table style={{ width: "100%", backgroundColor: "#fff" }}>
                                                        <tbody>

                                                            <tr style={{ fontSize: "12px", color: "rgba(0,0,0,0.87)", fontWeight: 600, border: "none !Important", backgroundColor: "#fff !Important", padding: "0 !Important" }}>
                                                                <td className={classes.noborder} style={{ width: "35%", wordBreak: "break-all" }}>
                                                                    <p><strong style={{ width: "200px" }}>
                                                                        {/* REMITENTE */
                                                                            traducirLabel(262)}
                                                                    </strong>
                                                                        {puedeEditar() &&
                                                                            <IconButton color="default" size="small" className={classes.oval}
                                                                                onClick={() => cambiarSeccion(enums.estatusSolicitud.origenDestino)}>
                                                                                <EditOutlined style={{ fontSize: 15 }} />
                                                                            </IconButton>
                                                                        }
                                                                    </p>

                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        <strong>{props.solicitud.distribuidorRemitente?.nombre}</strong>
                                                                    </p>
                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        {props.solicitud.direccionRemitente}
                                                                    </p>
                                                                </td>
                                                                <td className={classes.noborder}>

                                                                    <div style={{ width: "150px", height: "150px" }}>
                                                                        <Map setDireccion={props.solicitud.coloniaOrigen?.direccion}
                                                                            setCalle={props.solicitud.coloniaOrigen?.direccion}
                                                                            setCalleNumero={0}
                                                                            setEstado={props.solicitud.coloniaOrigen?.estado?.nombre}
                                                                            setZip={props.solicitud.coloniaOrigen?.nombre}
                                                                            height='150px'
                                                                            paisId={props.solicitud.coloniaOrigen?.pais.id}
                                                                            setLatitude={props.solicitud.distribuidorRemitente.latitude !== 0 ? props.solicitud.distribuidorRemitente.latitude : props.datosRemitente.latitude}
                                                                            setLongitude={props.solicitud.distribuidorRemitente.longitude !== 0 ? props.solicitud.distribuidorRemitente.longitude : props.datosRemitente.longitude}
                                                                            zoom={20}
                                                                            center={{ lat: props.solicitud.distribuidorRemitente.latitude !== 0 ? props.solicitud.distribuidorRemitente.latitude : props.datosRemitente.latitude, lng: props.solicitud.distribuidorRemitente.longitude !== 0 ? props.solicitud.distribuidorRemitente.longitude : props.datosRemitente.longitude }} />

                                                                    </div >
                                                                </td >
                                                                <td className={classes.noborder} style={{ width: "35%", wordBreak: "break-all" }}>
                                                                    <p><strong>{traducirLabel(85)}</strong>
                                                                        {puedeEditar() &&
                                                                            <IconButton color="default" size="small" className={classes.oval}
                                                                                onClick={() => cambiarSeccion(enums.estatusSolicitud.origenDestino, true)}>
                                                                                <EditOutlined style={{ fontSize: 15 }} />
                                                                            </IconButton>}
                                                                    </p>
                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        <strong>  {props.solicitud.distribuidorDestinatario?.nombre}</strong>
                                                                    </p>
                                                                    <p style={{ wordBreak: "break-word" }}>

                                                                        {props.solicitud.direccionDestinatario}
                                                                    </p>
                                                                </td>
                                                                <td className={classes.noborder}>

                                                                    <div style={{ width: "150px", height: "150px" }}>

                                                                        <Map setDireccion={props.solicitud.coloniaOrigen?.direccion}
                                                                            setCalle={props.solicitud.coloniaOrigen?.direccion}
                                                                            setCalleNumero={0}
                                                                            setEstado={props.solicitud.coloniaOrigen?.estado?.nombre}
                                                                            setZip={props.solicitud.coloniaOrigen?.nombre}
                                                                            height='150px'
                                                                            paisId={props.solicitud.coloniaOrigen?.pais.id}
                                                                            setLatitude={props.solicitud.distribuidorDestinatario.latitude !== 0 ? props.solicitud.distribuidorDestinatario.latitude : props.datosDestinatario.latitude}
                                                                            setLongitude={props.solicitud.distribuidorDestinatario.longitude !== 0 ? props.solicitud.distribuidorDestinatario.longitude : props.datosDestinatario.longitude}
                                                                            zoom={20}
                                                                            center={{ lat: props.solicitud.distribuidorDestinatario.latitude !== 0 ? props.solicitud.distribuidorDestinatario.latitude : props.datosDestinatario.latitude, lng: props.solicitud.distribuidorDestinatario.longitude !== 0 ? props.solicitud.distribuidorDestinatario.longitude : props.datosDestinatario.longitude }} />
                                                                    </div>
                                                                </td>
                                                            </tr >

                                                            <tr style={{ fontSize: "12px", color: "rgba(0,0,0,0.87)", fontWeight: 600 }}>
                                                                <td className={classes.noborder}>

                                                                    <p style={{ width: "150px" }}><strong> {props.solicitud.contactoOrigen?.nombre}</strong>
                                                                        {puedeEditar() &&
                                                                            <IconButton color="default" size="small" className={classes.oval}
                                                                                onClick={() => cambiarSeccion(enums.estatusSolicitud.origenDestino)}>
                                                                                <EditOutlined style={{ fontSize: 15 }} />
                                                                            </IconButton>}
                                                                    </p>
                                                                    <p> {props.solicitud.contactoOrigen?.telefono}</p>
                                                                    <p> {props.solicitud.contactoOrigen?.correo}</p>
                                                                </td >
                                                                <td className={classes.noborder}>

                                                                    <p>{formaEnvio}</p>
                                                                    <ul style={{ margin: 0, paddingLeft: "1.5em" }}>
                                                                        {fechaRad && <li>{fechaRad}</li>}

                                                                        {localStorage.getItem("idioma") === 'en-US' && props.solicitud.serviciosAdicionales?.map(sa =>
                                                                            sa.seleccionado && sa.aplicaOrigen ?
                                                                                <li key={sa.id}>{sa.etiquetaServicioAdicionalDto?.nombre == null ? sa.nombre : sa.etiquetaServicioAdicionalDto.nombre}</li> : null
                                                                        )
                                                                        }
                                                                        {localStorage.getItem("idioma") !== 'en-US' && props.solicitud.serviciosAdicionales?.map(sa =>
                                                                            sa.seleccionado && sa.aplicaOrigen ?
                                                                                <li key={sa.id}>{sa.nombre}</li> : null
                                                                        )
                                                                        }
                                                                    </ul>
                                                                </td>

                                                                <td className={classes.noborder}>
                                                                    <p style={{ width: "150px" }}><strong> {props.solicitud.contactoDestino?.nombre}</strong>
                                                                        {puedeEditar() &&
                                                                            <IconButton color="default" size="small" className={classes.oval}
                                                                                onClick={() => cambiarSeccion(enums.estatusSolicitud.origenDestino, true)}>
                                                                                <EditOutlined style={{ fontSize: 15 }} />
                                                                            </IconButton>}
                                                                    </p>
                                                                    <p> {props.solicitud.contactoDestino?.telefono}</p>
                                                                    <p> {props.solicitud.contactoDestino?.correo}</p>
                                                                </td>
                                                                <td className={classes.noborder}>
                                                                    <p>{entrega}</p>
                                                                    <ul style={{ margin: 0, paddingLeft: "1.5em" }}>
                                                                        {fechaEad && <li>{fechaEad}</li>}

                                                                        {localStorage.getItem("idioma") === 'en-US' && props.solicitud.serviciosAdicionales?.map(sa =>
                                                                            sa.seleccionado && sa.aplicaDestino ?
                                                                                <li key={sa.id}>{sa.concepto?.etiquetaConcepto?.nombreConcepto == null ? sa.nombre : sa.concepto?.etiquetaConcepto?.nombreConcepto}</li> : null
                                                                        )
                                                                        }
                                                                        {localStorage.getItem("idioma") !== 'en-US' && props.solicitud.serviciosAdicionales?.map(sa =>
                                                                            sa.seleccionado && sa.aplicaDestino ?
                                                                                <li key={sa.id}>{sa.nombre}</li> : null
                                                                        )
                                                                        }
                                                                    </ul>
                                                                </td>
                                                            </tr>

                                                        </tbody >
                                                    </table >

                                                </td >
                                            </tr >

                                        </tbody >
                                    </table >
                                </Box >

                                <br />
                                <Divider />

                                <Box display="flex" flexDirection="column" mt={3}>
                                    <Box display="flex" mb={1}>
                                        <BusinessCenterOutlined />
                                        <Box ml={1}><b className={classes.seccionTitulo}>{traducirLabel(88)}</b></Box>
                                        {
                                            puedeEditar() &&
                                            <IconButton color="default" size="small" className={classes.oval}
                                                onClick={() => cambiarSeccion(enums.estatusSolicitud.datosMercancia)}>
                                                <EditOutlined style={{ fontSize: 15 }} />
                                            </IconButton>
                                        }
                                    </Box >

                                    <Box ml={4}>
                                        <TableContainer component={Paper}>
                                            <Table className="table-xs" size="small" aria-label="a dense table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center">
                                                            {/* No. */traducirLabel(193)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Cant. */traducirLabel(29)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Embalaje */traducirLabel(111)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Largo x Ancho x Alto */traducirLabel(174)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Volumen */traducirLabel(320)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Peso */traducirLabel(229)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* No Estibable */traducirLabel(190)}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.mercancias.length > 0 && props.mercancias?.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">{index + 1}</TableCell>
                                                            <TableCell align="center"> {row.cantidad}</TableCell>
                                                            {localStorage.getItem("idioma") === 'en-US' &&
                                                                <TableCell align="center">{row.embalaje?.etiquetaEmbalaje?.nombre != undefined ? row.embalaje?.etiquetaEmbalaje?.nombre : row.embalaje}</TableCell>
                                                            }
                                                            {localStorage.getItem("idioma") !== 'en-US' &&
                                                                <TableCell align="center">{row.embalaje?.nombre != undefined ? row.embalaje?.nombre : row.embalaje}</TableCell>
                                                            }
                                                            <TableCell
                                                                align="center">{`${row.largo} x ${row.ancho} x ${row.alto}`}</TableCell>
                                                            <TableCell align="center">{row.volumen?.toFixed(3)}</TableCell>
                                                            <TableCell align="center">{Number.isInteger(row.peso ?? 0) ? row.peso : row.peso?.toFixed(3)}</TableCell>
                                                            {localStorage.getItem("idioma") === 'en-US' &&
                                                                <TableCell align="center">{row.esEstibable ? 'Yes' : 'No'}</TableCell>
                                                            }
                                                            {localStorage.getItem("idioma") !== 'en-US' &&
                                                                <TableCell align="center">{row.esEstibable ? 'Si' : 'No'}</TableCell>
                                                            }
                                                            
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>

                                    <br />
                                    <Divider />
                                    <br />
                                    <Box display="flex" mb={1}>
                                        <AttachFile />
                                        <Box ml={1}><b className={classes.seccionTitulo}>
                                            {/* Archivos Adjuntos */
                                                traducirLabel(328)}
                                        </b></Box>
                                    </Box>
                                    <Box ml={4}>
                                        {props.solicitud.archivosAdjuntos && props.solicitud.archivosAdjuntos.length === 0 &&
                                            <span style={{ fontSize: "14px" }}>
                                                {/* No se adjuntaron archivos */
                                                    traducirLabel(329)}
                                            </span>}
                                        {props.solicitud.archivosAdjuntos && props.solicitud.archivosAdjuntos.length > 0 &&
                                            <TableContainer component={Paper}>
                                                <Table className="table-xs" size="small" aria-label="a dense table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center">
                                                                {/* Nombre Archivo */
                                                                    traducirLabel(202)}
                                                            </TableCell>
                                                            <TableCell align="center" />
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {props.solicitud.archivosAdjuntos?.map((row, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell >
                                                                    {row.nombreArchivo && row.nombreArchivo !== '' && <span> {row.nombreArchivo} </span>}
                                                                    {row.nombre && row.nombre !== '' && <span> {row.nombre} </span>}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.nombreArchivo && row.nombreArchivo !== '' &&
                                                                        <Button className={classes.icon} variant="contained" color="primary" onClick={() => handleDownload(row)}>
                                                                            <ArrowDownwardIcon />
                                                                        </Button>
                                                                    }
                                                                    {row.nombre && row.nombre !== '' &&
                                                                        <Button className={classes.icon} variant="contained" color="primary" onClick={() => handleDownload(row)}>
                                                                            <ArrowDownwardIcon />
                                                                        </Button>
                                                                    }
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>}
                                    </Box>
                                </Box >
                            </Grid >

                            <Grid item xs={12} md={4}>
                                <Box style={{ backgroundColor: "#f5f5f5" }}>
                                    <Box p={3}>
                                        <ButtonGroup color="primary" aria-label="contained primary button group">
                                            {props.cliente.monedaID == 1 &&
                                                <>
                                                    <Button variant="contained">MXN</Button>
                                                    <Button variant="outlined" disabled={true}>USD</Button>
                                                </>
                                            }
                                            {props.cliente.monedaID != 1 &&
                                                <>
                                                    <Button variant="outlined" disabled={true}>MXN</Button>
                                                    <Button variant="contained" >USD</Button>
                                                </>
                                            }
                                        </ButtonGroup>

                                        <Box className={classes.title}>
                                        {traducirLabel(122) /* ENVÍO */ } 
                                            {
                                                puedeEditar() &&
                                                <IconButton color="default" size="small" className={classes.oval}
                                                    onClick={() => cambiarSeccion(enums.estatusSolicitud.tipoEnvio)}>
                                                    <EditOutlined style={{ fontSize: 15 }} />
                                                </IconButton>
                                            }
                                        </Box >

                                        <Box className={classes.information}>
                                            {props.solicitud.tipoEnvio?.nombre}
                                        </Box>

                                        <Box className={classes.title}>
                                            {/* SERVICIO */ traducirLabel(276)}
                                        </Box>

                                        <Box className={classes.information}>
                                            {props.solicitudCopia.tipoServicio?.nombre}
                                        </Box>

                                        {props.cliente.esClase == true &&
                                            <>
                                                <Box className={classes.title}>
                                                    {/* Clase */
                                                        traducirLabel(34)}
                                                </Box>

                                                <Box className={classes.information}>
                                                    {props.solicitud.clase}
                                                </Box>
                                            </>
                                        }

                                        <table className={classes.tableSummary} style={{ marginTop: '0.7em' }}>
                                            <tbody>
                                                <tr className={classes.title}>
                                                    <td colSpan={2}>
                                                        {/* PESO FACTURADO */ traducirLabel(230)}
                                                    </td>
                                                </tr>
                                                <tr className={classes.information}>
                                                    {localStorage.getItem("idioma")!=='en-US' &&
                                                        <td>{props.solicitud.totalPesoFacturado ? props.solicitud.totalPesoFacturado : 0}  {props.solicitud.unidadMedidaPesoId == 1 ? 'kg.' : 'Lib.'} </td>
                                                    }
                                                    {localStorage.getItem("idioma")==='en-US' &&
                                                        <td>{props.solicitud.totalPesoFacturado ? props.solicitud.totalPesoFacturado : 0}  {props.solicitud.unidadMedidaPesoId == 1 ? 'kg.' : 'Pound.'} </td>
                                                    }
                                                    
                                                    <td className="price">{props.solicitud.montoPesoFacturado ? currencyFormat(props.solicitud.montoPesoFacturado) : currencyFormat(0)}
                                                    </td>
                                                </tr>
                                                <tr className={classes.title}>
                                                    <td colSpan={2} style={{ paddingTop: '2em' }}>
                                                        {traducirLabel(278)}
                                                        {puedeEditar() &&
                                                            <IconButton color="default" size="small"
                                                                className={classes.oval}
                                                                onClick={() => cambiarSeccion(enums.estatusSolicitud.serviciosAdicionales)}>
                                                                <EditOutlined style={{ fontSize: 15 }} />
                                                            </IconButton>}
                                                    </td>
                                                </tr>
                                                {localStorage.getItem("idioma") === 'en-US' && props.solicitud.serviciosAdicionales?.map(sa => sa.id && sa.id !== 480 &&
                                                    <tr className={classes.information}>
                                                        <td>{(sa.concepto?.etiquetaConcepto?.nombreConcepto === null || sa.concepto?.etiquetaConcepto?.nombreConcepto === '') ? (sa.concepto ? sa.concepto.nombreConcepto : sa.nombre) : sa.concepto?.etiquetaConcepto.nombreConcepto}</td>
                                                        <td className="price">{currencyFormat(sa.costo ? sa.costo : sa.cantidad)}</td>
                                                    </tr>
                                                )}
                                                {localStorage.getItem("idioma") !== 'en-US' && props.solicitud.serviciosAdicionales?.map(sa => sa.id && sa.id !== 480 &&
                                                    <tr className={classes.information}>
                                                        <td>{sa.concepto ? sa.concepto.nombreConcepto : sa.nombre}</td>
                                                        <td className="price">{currencyFormat(sa.costo ? sa.costo : sa.cantidad)}</td>
                                                    </tr>
                                                )}

                                                {props.solicitud.markupMonto != undefined && props.solicitud.markupMonto > 0 &&
                                                    <>
                                                        <tr className={classes.information}>
                                                            <td>
                                                                {/* MARKUP */ traducirMessage(181)}
                                                            </td>
                                                            <td className="price">{currencyFormat(props.solicitud.markupMonto)}</td>
                                                        </tr>
                                                    </>
                                                }
                                                <tr className={classes.title}>
                                                    <td colSpan={2} style={{ paddingTop: '2em' }}>
                                                        {/* TIPO DE SEGURO */traducirLabel(302)}
                                                    </td>
                                                </tr>
                                                <tr className={classes.information}>
                                                    <td>{props.solicitudCopia.esSeguroBasico ? traducirLabel(273) : props.solicitudCopia.esSeguroMercancia ? traducirLabel(274) : ''}</td>
                                                    <td className="price">{props.solicitudCopia.esSeguroBasico ? currencyFormat(Number(props.solicitud.costoSeguro)) : currencyFormat(Number(props.solicitud.valorMercancia) * .01)}</td>
                                                </tr>
                                                <tr style={{ height: '40px' }}>
                                                    <td colSpan={2}>
                                                        <Divider />
                                                    </td>
                                                </tr>

                                                <tr className={classes.information}
                                                    style={{ height: '35px', verticalAlign: 'bottom' }}>
                                                    <td>
                                                        {/* Subtotal */traducirLabel(287)}
                                                    </td>
                                                    <td className="price">{props.solicitud.subtotal ? currencyFormat(props.solicitud.subtotal) : currencyFormat(0)}</td>
                                                </tr>

                                                <tr className={classes.information}>
                                                    <td>
                                                        {/* IVA */traducirLabel(166)}
                                                    </td>
                                                    <td className="price">{props.solicitud.iva ? currencyFormat(props.solicitud.iva) : currencyFormat(0)}</td>
                                                </tr>

                                                <tr className={classes.information}>
                                                    <td>
                                                        {/* Retención IVA */traducirLabel(267)}
                                                    </td>
                                                    <td className="price">{props.solicitud.retencion ? currencyFormat(props.solicitud.retencion) : currencyFormat(0)}</td>
                                                </tr>
                                            </tbody>
                                        </table >
                                    </Box >

                                    <Box style={{ backgroundColor: "#338462" }}>
                                        <Box px={3} py={2}>
                                            <table className={classes.tableSummary}>
                                                <tbody>
                                                    <tr className={classes.total}>
                                                        <td>
                                                            {/* TOTAL */traducirLabel(305)}
                                                        </td>
                                                        <td className="price">{props.solicitud.total ? currencyFormat(props.solicitud.total) : currencyFormat(0)}</td>

                                                    </tr>
                                                    <tr style={{ height: '40px', color: 'white' }}>
                                                        <td colSpan={2}>
                                                            <Divider />
                                                        </td>
                                                    </tr>
                                                    <tr className={classes.mensajePrecio}>
                                                        <td>
                                                            {/* * Precios sujetos a medición y pesaje de la mercancía. */traducirMessage(8)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Box>
                                    </Box>
                                </Box >
                            </Grid >
                        </Grid >
                    </Box >
                </Paper >
                {
                    props.solicitud.modificar &&
                    <Box display="flex" justifyContent="flex-end" mt={2} mb={3}>
                    </Box>
                }
            </>
        }
        {
            showLoading &&
            <> <LoadingDialog titulo="Procesando" abierto={true} /></>
        }
        {
            showEnviarCorreo &&
            <EnviarCorreoDialog tipo="solicitud servicio" cerrar={cerrarEnviarCorreo} confirmar={confirmarEnviarCorreo}
                abierto={showEnviarCorreo} registroId={props.solicitud.id}
                abrirConfirmar={!opcionesEnvio.terminado} />
        }

        <ImprimirDialog titulo={traducirLabel(161)} contenido={props.solicitud.numGuia} abierto={imprimirAbierto}
            solicitud={imprimirSolicitud} etiquetadora={imprimirEtiquetadora} lasser={imprimirLasser}
            cerrar={cerrarImprimir} />

        {
            opcionesEnvio.dialogOpen &&
            // "Al imprimir ya no podrá hacer modificaciones ¿Desea continuar?"
            <ConfirmDialog titulo={traducirLabel(164)} abierto={opcionesEnvio.dialogOpen}
                confirmar={() => terminarSolicitud(true)}
                contenido={traducirMessage(277)}
                cerrar={() => setOpcionesEnvio({ ...opcionesEnvio, dialogOpen: false })} />
        }
    </>)


};

const mapStateToProps = (state: ApplicationState) => ({
    solicitud: state.solicitud,
    usuario: state.usuario,
    mercancias: state.mercancias,
    solicitudCopia: state.solicitudCopia,
    cliente: state.cliente
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    setRecoleccionOrigen: setRecoleccionOrigen,
    setRecoleccionDestino: setRecoleccionDestino,
    saveMercancias: saveMercancias
};

export default connect(mapStateToProps, mapDispatchToProps)(ResumenConfirmacionSS);
